import { getApiErrorMessage } from "./getApiErrorMessage";

/**
 * Maps product / catalog API `message` strings to i18n keys (EN backend → AR UI).
 */
const PRODUCT_API_MESSAGE_TO_KEY = {
  "Product updated successfully.": "productApiMsgs.updatedSuccessfully",
  "Product updated successfully": "productApiMsgs.updatedSuccessfully",
  "Product updated successfully locally and in Jahez.":
    "productApiMsgs.updatedLocallyAndJahez",
  "Product created successfully in both local DB":
    "productApiMsgs.createdSuccessfully",
  "Product created successfully in both local DB and Jahez.":
    "productApiMsgs.createdSuccessfully",
  "Product added successfully.": "productApiMsgs.addedSuccessfully",
  "Product deleted successfully.": "productApiMsgs.deletedSuccessfully",
  "Product deleted successfully": "productApiMsgs.deletedSuccessfully",
  "Product removed from catalog successfully.":
    "productApiMsgs.removedFromCatalog",
  "Product not found.": "productApiMsgs.notFound",
  "Product not found": "productApiMsgs.notFound",
  "Product is not associated with a store.": "productApiMsgs.notAssociatedWithStore",
  "Product creation failed while initializing inventory.":
    "productApiMsgs.creationInventoryFailed",
  "Failed to update product": "productApiMsgs.failedToUpdate",
  "Failed to add product.": "productApiMsgs.failedToAdd",
  "Failed to delete product": "productApiMsgs.failedToDelete",
  "Failed to update availability": "productApiMsgs.failedToUpdateAvailability",
  "Nutrition facts updated successfully.": "productApiMsgs.nutritionUpdated",
  "Nutrition facts updated successfully": "productApiMsgs.nutritionUpdated",
  "Menu updated successfully!": "productApiMsgs.menuUpdated",
  "Menu update failed!": "productApiMsgs.menuUpdateFailed",
  "Menu update failed try again!": "productApiMsgs.menuUpdateFailedRetry",
  "Catalog updated successfully.": "productApiMsgs.catalogUpdated",
  "Catalog updated successfully": "productApiMsgs.catalogUpdated",
  "Failed to update catalog": "productApiMsgs.failedToUpdateCatalog",
  "Weights updated successfully": "productApiMsgs.weightsUpdated",
  "Failed to update weights": "productApiMsgs.failedToUpdateWeights",
  "Your store list has been updated": "productApiMsgs.storeListUpdated",
  "System": "productApiMsgs.system",
  "An error occurred": "productApiMsgs.anErrorOccurred",
  "Unknown Error": "productApiMsgs.unknownError",
};

/**
 * @param {unknown} message
 * @param {import('i18next').TFunction} t
 * @returns {string}
 */
export function translateProductApiMessage(message, t) {
  if (message == null || message === "") return "";
  const s = String(message).trim();
  const mapped = PRODUCT_API_MESSAGE_TO_KEY[s];
  if (mapped) return t(mapped);
  return t(s, { defaultValue: s });
}

/**
 * @param {unknown} err
 * @param {import('i18next').TFunction} t
 * @param {string} fallbackKey
 * @returns {string}
 */
export function resolveProductApiError(err, t, fallbackKey) {
  const raw = getApiErrorMessage(err);
  if (raw) return translateProductApiMessage(raw, t);
  return t(fallbackKey);
}
